module.exports = __webpack_public_path__ + "img/screen-manual-3.92248991.png";